/*
 * Every colour is a token, so the form reads on the dark surface or on the light panel
 * the contact page puts it on. Fields are 3rem tall with 1rem text: a comfortable tap
 * target, and iOS Safari does not zoom into an input whose text is 16px or larger.
 */
.form {
  display: grid;
  gap: var(--sp-5);
}
.field {
  display: grid;
  gap: var(--sp-2);
  min-width: 0;
}
.form label,
.form legend {
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--text-strong);
}
.optional {
  font-weight: 400;
  color: var(--text-muted);
}
.form input:not([type="radio"]),
.form textarea {
  width: 100%;
  min-height: 3rem;
  padding: var(--sp-3) var(--sp-4);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-sm);
  background: var(--surface-raised);
  color: var(--text-strong);
  font: inherit;
  font-size: 1rem;
  transition:
    border-color var(--dur) var(--ease),
    box-shadow var(--dur) var(--ease);
}
.form textarea {
  /* No drag grip: the box is tall enough for a message and resizing it only breaks the
     layout it sits in. */
  resize: none;
  min-height: 8.5rem;
  line-height: 1.5;
}
.form input::placeholder,
.form textarea::placeholder {
  color: var(--text-muted);
}
.form input:not([type="radio"]):hover,
.form textarea:hover {
  border-color: var(--text-muted);
}
.form input:not([type="radio"]):focus-visible,
.form textarea:focus-visible {
  outline: none;
  border-color: var(--focus);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--focus) 30%, transparent);
}
.form [aria-invalid="true"] {
  border-color: var(--danger);
}
.row {
  display: grid;
  gap: var(--sp-5);
}
@media (min-width: 30rem) {
  .row {
    grid-template-columns: 1fr 1fr;
  }
}

/* ---- what they want: three choices as tappable options, not a dropdown ---------- */
.choices {
  display: grid;
  gap: var(--sp-2);
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}
.options {
  display: grid;
  gap: var(--sp-2);
}
@media (min-width: 30rem) {
  .options {
    grid-template-columns: repeat(3, 1fr);
  }
}
.option {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  min-height: 3rem;
  padding: var(--sp-2) var(--sp-4);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-sm);
  background: var(--surface-raised);
  cursor: pointer;
  transition:
    border-color var(--dur) var(--ease),
    background-color var(--dur) var(--ease);
}
.form .option {
  font-size: var(--fs-sm);
  font-weight: 600;
}
.option:hover {
  border-color: var(--text-muted);
}
.option input {
  flex: none;
  width: 1.125rem;
  height: 1.125rem;
  margin: 0;
  accent-color: var(--accent);
}
.option:has(input:checked) {
  border-color: var(--accent);
  background: color-mix(in srgb, var(--accent) 10%, var(--surface-raised));
}
.option:has(input:focus-visible) {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

/* ---- errors, the send button and what we promise ---------------------------------- */
.error {
  margin: 0;
  color: var(--danger);
  font-size: var(--fs-sm);
  font-weight: 600;
}
.alert {
  margin: 0;
  padding: var(--sp-3) var(--sp-4);
  border: 1px solid var(--danger);
  border-radius: var(--radius-sm);
  color: var(--text-strong);
}
.submit {
  display: grid;
  gap: var(--sp-3);
  margin-top: var(--sp-1);
}
.button {
  width: 100%;
  min-height: 3rem;
  font-size: 1rem;
}
.promise {
  margin: 0;
  font-size: var(--fs-sm);
  color: var(--text-muted);
}
@media (min-width: 48rem) {
  .submit {
    grid-template-columns: auto 1fr;
    align-items: center;
    column-gap: var(--sp-5);
  }
  .button {
    width: auto;
    padding-inline: var(--sp-8);
  }
}

.honeypot {
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}
/* The thank-you, and the email-us note when the build has no endpoint. */
.note {
  display: grid;
  gap: var(--sp-3);
}
.note p {
  margin: 0;
}
.noteTitle {
  margin: 0;
  font-size: var(--fs-xl);
}
